import { render, staticRenderFns } from "./ChargeTransactionModal.vue?vue&type=template&id=452c2b5b&"
import script from "./ChargeTransactionModal.vue?vue&type=script&lang=js&"
export * from "./ChargeTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./ChargeTransactionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports